import React, { useEffect, createElement } from 'react';
import AdvertorialEVHiddenEnemy from '../components/Advertorial-EV-Hidden-Enemy';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function EVHiddenEnemy() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with Pixel ID
    window.fbq('init', '2530845004033567');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'EV Hidden Enemy',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'Advertorial_Scroll_50');
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'Advertorial_Scroll_90');
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-3663">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-3664">
        <Helmet data-id="element-3665">
          <title data-id="element-3666">
            What's Happening to Your Body Every Time You Sit in Your Electric
            Vehicle
          </title>
          <meta property="og:title" content="What's Happening to Your Body Every Time You Sit in Your Electric Vehicle" data-id="element-3667" />
          <meta property="og:description" content="What a Raytheon electromagnetic engineer found when his daughter kept getting sick after every drive — and what he wishes every EV family knew before getting in the car." data-id="element-3668" />
          <meta property="og:type" content="article" data-id="element-3669" />
          <meta property="og:url" content={window.location.href} data-id="element-3670" />
          <meta property="og:image:width" content="1200" data-id="element-3671" />
          <meta property="og:image:height" content="630" data-id="element-3672" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-3673" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-3674" />
          <meta name="twitter:title" content="What's Happening to Your Body Every Time You Sit in Your Electric Vehicle" data-id="element-3675" />
          <meta name="twitter:description" content="What a Raytheon electromagnetic engineer found when his daughter kept getting sick after every drive — and what he wishes every EV family knew before getting in the car." data-id="element-3676" />
          <meta name="twitter:url" content={window.location.href} data-id="element-3677" />
        </Helmet>
        <AdvertorialEVHiddenEnemy data-id="element-3678" />
      </div>
    </HelmetProvider>;
}